module.exports = __webpack_public_path__ + "img/logo-minimized.c42983ad.png";